module.exports = __webpack_public_path__ + "img/Missing Hallmark.ae13a8e9.png";